import Layout from "components/structure/Layout";
import React, { useCallback } from "react";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import Delegation from "assets/delegation.svg";
import ConflictIndicator from "assets/conflict_indicator.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RoleService from "services/RoleService";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import UserCreationService from "services/UserCreationService";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { AuthData } from "auth/AuthWarpper";
import { useTranslation } from "react-i18next";
import AccessTable from "../../Common/AccessTable";
import CustomPagination from "components/pages/Import/Common/CustomPagination";


const mockRoles = [
  {
    startDate: "2025-07-01T09:00:00.000Z",
    endDate: "2025-12-31T18:00:00.000Z",
    roleName: "IT Admin Access Mgt",
    serviceNumber: "SN001",
    remarks: "Primary IT Admin Role",
    active: true,
    createdDateTimeUTC: "2025-07-01T09:00:00.000Z"
  },
  {
    startDate: "2025-08-01T09:00:00.000Z",
    endDate: "2026-01-31T18:00:00.000Z",
    roleName: "Business Admin",
    serviceNumber: "SN002",
    remarks: "Secondary Business Role",
    active: false,
    createdDateTimeUTC: "2025-08-01T09:00:00.000Z"
  },
  {
    startDate: "2025-07-15T09:00:00.000Z",
    endDate: "2026-02-28T18:00:00.000Z",
    roleName: "System Analyst",
    serviceNumber: "SN003",
    remarks: "System Analysis Role",
    active: true,
    createdDateTimeUTC: "2025-07-15T09:00:00.000Z"
  },
  {
    startDate: "2025-09-01T09:00:00.000Z",
    endDate: "2026-03-31T18:00:00.000Z",
    roleName: "Data Manager",
    serviceNumber: "SN004",
    remarks: "Data Management Role",
    active: false,
    createdDateTimeUTC: "2025-09-01T09:00:00.000Z"
  },
  {
    startDate: "2025-10-01T09:00:00.000Z",
    endDate: "2026-04-30T18:00:00.000Z",
    roleName: "Support Specialist",
    serviceNumber: "SN005",
    remarks: "Technical Support Role",
    active: true,
    createdDateTimeUTC: "2025-10-01T09:00:00.000Z"
  },
  {
    startDate: "2025-11-01T09:00:00.000Z",
    endDate: "2026-05-31T18:00:00.000Z",
    roleName: "Project Manager",
    serviceNumber: "SN006",
    remarks: "Project Management Role",
    active: false,
    createdDateTimeUTC: "2025-11-01T09:00:00.000Z"
  }
];
const UserCreation = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [data, setData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const fetchData = async (page = 0, pageSize = itemsPerPage) => {
    setLoading(true);
    try {
      const response = await UserCreationService.getAdministratorUserCreation(page, pageSize);
      const responseData = response.data.response?.user || [];
      setTotalItems(response.data.response.totalItems);


      let rows = responseData?.map((item) => ({
        userId: item.userId,
        batOneId: item.batOneId,
        profileCode: item.profileCode,
        profileName: item.profileName,
        profileId: item.profileId,
        profileAttribute: item.profileAttribute,
        countryCode: item.countryCode,
        countryName: item.countryName,
        email: item.email,
        active: item.active === true ? "Active" : "InActive",
        isDeleted: item.isDeleted,
        createdByUser: item.createdByUser,
        modifiedDateTimeUTC: item.modifiedDateTimeUTC,
        modifiedByUser: item.modifiedByUser,
        userName: item.userName,
        startDate: item.startDate,
        endDate: item.endDate,
        remarks: item.remarks,
        serviceNumber: item.serviceNumber,
        userAttribute: item.userAttribute,
        isEditableForAdministrator: item.isEditableForAdministrator

      }));
      rows = rows.map((item) => ({
        ...item,
        mockRoles: mockRoles,
      }));
      setData(rows);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);


  const searchData = async (query, page, pageSize) => {
    setLoading(true);
    try {
      const response = await UserCreationService.searchAdministratorUser(query, page, pageSize);
      const responseData = response.data.response?.user || [];
      setTotalItems(response.data.response.totalItems);
        const rows = responseData?.map((item) => ({
          userId: item.userId,
          batOneId: item.batOneId,
          profileCode: item.profileCode,
          profileName: item.profileName,
          profileId: item.profileId,
          profileAttribute: item.profileAttribute,
          countryCode: item.countryCode,
          countryName: item.countryName,
          email: item.email,
          active: item.active === true ? "Active" : "InActive",
          isDeleted: item.isDeleted,
          createdByUser: item.createdByUser,
          modifiedDateTimeUTC: item.modifiedDateTimeUTC,
          modifiedByUser: item.modifiedByUser,
          userName: item.userName,
          startDate: item.startDate,
          endDate: item.endDate,
          remarks: item.remarks,
          serviceNumber: item.serviceNumber,
          userAttribute: item.userAttribute,
          isEditableForAdministrator: item.isEditableForAdministrator
        }));

        setData(rows);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setSeverity("error");
        setMessage("No Record Found");
        setOpenAlert(true);
        setData([]);
        setLoading(false);
      }
    }

  const handleSearch = useCallback(
    debounce(async (query) => {
      setCurrentPage(0);
    
    // If query length is 0 or only contains spaces, fetch all data
    if (!query.trim()) {
      fetchData(0, itemsPerPage);
      return;
    }

    // Only search if there's a valid query
    if (query.length >= 1) {
      setLoading(true);
      try {
        const response = await UserCreationService.searchAdministratorUser(query, 0, itemsPerPage);
        const responseData = response.data.response?.user || [];
        setTotalItems(response.data.response.totalItems);
        const rows = responseData?.map((item) => ({
          userId: item.userId,
          batOneId: item.batOneId,
          profileCode: item.profileCode,
          profileName: item.profileName,
          profileId: item.profileId,
          profileAttribute: item.profileAttribute,
          countryCode: item.countryCode,
          countryName: item.countryName,
          email: item.email,
          active: item.active === true ? "Active" : "InActive",
          isDeleted: item.isDeleted,
          createdByUser: item.createdByUser,
          modifiedDateTimeUTC: item.modifiedDateTimeUTC,
          modifiedByUser: item.modifiedByUser,
          userName: item.userName,
          startDate: item.startDate,
          endDate: item.endDate,
          remarks: item.remarks,
          serviceNumber: item.serviceNumber,
          userAttribute: item.userAttribute
        }));
        setData(rows);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setSeverity("error");
        setMessage("No Record Found");
        setOpenAlert(true);
        setData([]);
      } finally {
        setLoading(false);
      }
    }
  }, 500),
    []
  );

  const paginate = (pageNumber, newItemsPerPage) => {
    setCurrentPage(pageNumber - 1);
    setItemsPerPage(newItemsPerPage);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), pageNumber - 1, newItemsPerPage);
    } else {
      fetchData(pageNumber - 1, newItemsPerPage);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), newPage, itemsPerPage);
    } else {
      fetchData(newPage, itemsPerPage);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setItemsPerPage(newPageSize);
    setCurrentPage(0);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), 0, newPageSize);
    } else {
      fetchData(0, newPageSize);
    }
  };

  const columns = [
    { label: t("userCreation.name"), field: "userName", align: "left" },
    { label: t("BAT One ID"), field: "batOneId", align: "left" },
    { label: t("Country"), field: "countryName", align: "left" },
    { label: t("Attribute"), field: "userAttribute", align: "left" },
    { label: t("Status"), field: "active", align: "left" },
    { label: t("Action"), field: "action", align: "left" },
  ];

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box>
              <TextField
                sx={{ width: "403px" }}
                fullWidth
                value={searchQuery}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchQuery(value);
                  handleSearch(value);
                }}
                placeholder={t("search")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={() => navigate("/conflictIndicator")}
                // variant="outlined"
                sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={ConflictIndicator} alt="Conflict Indicator" />}
              >
                {t("userCreation.conflictIndicator")}
              </Button>
              <Button
                // variant="outlined"
                sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={Delegation} alt="delegation" />}
                onClick={() => navigate('/selfDelegationList', { state: { fromUrl: "administratorUserList" } })}
              >
                {t("delegation")}
              </Button>
              <Button
                // variant="outlined"
                onClick={() => navigate("/administratorUserAdd")}
                sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={AddButton} alt="add" />}
              >
                {t("addNewUser")}
              </Button>
            </Box>
          </Box>

          <AccessTable
            columns={columns}
            rows={data}
            url={"/editAdministratorUserAdd"}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 5,
                mb: 2,
              }}
            >
              <Button
                sx={{
                  borderRadius: 2,
                  background: "#EF7D00",
                  color: "#ffffff",
                  fontWeight: 600,
                  height: 54,
                  width: { xs: "100%", md: "156px" },
                  "&:hover": {
                    backgroundColor: "#EF7D00",
                  },
                }}
                onClick={() => navigate("/export", { state: 'userAdmin', profileInfo: user?.userAttribute, extractType: 'user' })}
              >
                {t("export")}
              </Button>
            </Box>
          </Box>
        </Box>
        {data?.length > 0 &&
          <div style={{ position: "absolute", width: "calc(100% - 1px)", marginLeft:"-24px", bottom: "0px" }}>
            {data &&
              <CustomPagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage={(v) => setItemsPerPage(v)}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
              />
            }
          </div>
        }
      </Box>
    </LayoutAccessManagement>
  );
};

export default UserCreation;
